import { render } from "./Navbar.vue?vue&type=template&id=1d24950a"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=1d24950a&lang=scss"
script.render = render

export default script